import { useTranslation } from "react-i18next";
import { TopicsInterestsEditor } from "../../../../components/interests/TopicsInterestsEditor";
import { SettingsPage, SettingsSection } from "../components/SettingsPanel";

/**
 * The topics that shape the feed, for the accounts that are asked this question
 * rather than the practice one: the nav's practice entry opens it for them
 * (Figma draws only "My practice").
 *
 * Hosts the SAME editor the Discovery sheet and the mobile settings host. The
 * `-mx-5` cancels the editor's own gutter so its chips line up with the panel's
 * reading column.
 */
export function InterestsSection(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <SettingsPage back={null}>
      <SettingsSection
        title={t("Pick your interests")}
        description={t("Choose the topics for your feed")}
      >
        <div className="-mx-5 flex min-h-0 flex-col">
          <TopicsInterestsEditor
            surface="desktop"
            onSaved={() => {
              // Stay on the panel: the success toast confirms.
            }}
          />
        </div>
      </SettingsSection>
    </SettingsPage>
  );
}
